import React, { useContext, type ReactNode } from 'react';
import { Collapse } from '../../Transition';
import { AccordionContext } from './AccordionContext';

/**
 * Main content of Accordion. Uses Collapse component to animate
 */
export const AccordionDetails = React.forwardRef<
  HTMLDivElement,
  { children: ReactNode }
>(({ children }, ref) => {
  const { isOpen } = useContext(AccordionContext);
  return (
    <Collapse in={isOpen} timeout={350}>
      <div ref={ref} className='hg-accordion__details'>
        {children}
      </div>
    </Collapse>
  );
});
AccordionDetails.displayName = 'Accordion.Details';
